import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetInformacionGeneralContribuyente } from '../shared/interfaces/seguridad';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class WebContribuyenteService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/web-contribuyente`;
  }

  public documentoSolicitudFirmaElectronica(): Observable<Blob> {
    const headers = new HttpHeaders({
      'Accept': 'application/pdf'
    });
    return this.http.get(`${this.baseUrl}/documento-solicitud-firma-electronica`, { headers, responseType: 'blob' });
  }

  public registrarSolicitudFirmaElectronica(codigo: string): Observable<string> {
    return this.http.post(`${this.baseUrl}/registrar-firma-electronica/${codigo}`, {}, { responseType: 'text' });
  }

  public habilitarFirmaElectronica(codigo: string): Observable<string> {
    return this.http.post(`${this.baseUrl}/habilitar-firma-electronica/${codigo}`, {}, { responseType: 'text' });
  }

  public enviarCorreoSolicitudFirmaElectronica(): Observable<string> {
    return this.http.get(`${this.baseUrl}/enviar-correo-solicitud-firma-electronica`, { responseType: 'text' });
  }

  public getInformacionGeneralContribuyente(): Observable<IGetInformacionGeneralContribuyente> {
    return this.http.get<IGetInformacionGeneralContribuyente>(`${this.baseUrl}/informacion-general`);
  }

  public renovarFirmaElectronica(codigo: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/renovar-firma-electronica/${codigo}`, {});
  }
}
